import {React, useEffect, useState, useContext} from 'react'
import RuralWomenWagesData from '../../../../Components/RuralWomenWagesData'
import { MyContextProvider } from "../../../../App";
import axios from "axios";
import { API_URL } from '../../../../Constant';
import { GlobalLoading, showLoading } from 'react-global-loading';
import {shortMonthToFull,handleUserLevelAccessPermissions,getAllYears,validateRoles,shortMonthToMonthNumber} from '../../../../Custom/Custom'
import messages from '../.././../../assets/Messages.json'
import { ToastContainer, toast } from 'react-toastify';
import { jwtDecode } from 'jwt-decode';
import { useNavigate } from "react-router-dom";
import priceTitle from '../../../../price.json';
import titlesData from '../../../../titles.json';






function RuralWomenWages() {
      const [districtList, setDistrictList] = useState([]);
      const [years, setYears] = useState([]);
      const [months, setMonth] = useState([]);
      const [districtCode, setDistrictCode] = useState('');
      const [districtName, setDistrictName] = useState('');
      const [yearName, setYearName] = useState('');
      const [monthName, setMonthName] = useState('');
      const [ruralWomenWagesRates, setRuralWomenWagesRates] = useState([]);
      const [blockAllData, setBlockAllData] = useState([]);
      const [averageData, setAverageData] = useState([]);
      const [isDivision, setIsDivision ] = useState(false);
      const [isDistrict, setIsDistrict ] = useState(false);
      const [buttonAccess, setButtonAccess] =  useState({userLevel:'',roles:'',isVisible:false});
      const token = useContext(MyContextProvider).token;
      const decode_token =jwtDecode(token)
      const [payload, setPayload] = useState([]);
      const navigate = useNavigate();
      const ruralWomenEmptyObject={
        "cowTotalWagesAvg": "",
        "buffaloTotalWagesAvg": "",
        "showingTotalWagesAvg": "",
        "weddingTotalWagesAvg": "",
        "harvestingTotalWagesAvg": "",
        "threshingTotalWagesAvg": "",
        "otherTotalWagesAvg": "",
        "WageMonth": "",
        "WageYear": "",
        "BlockCode": "",
        "LocationCode": "",
        "BlockName": "",
        "BuffaloTotalWages": "",
        "CowTotalWages": "",
        "CreatedBy": "",
        "CreatedTime": "",
        "DistrictCode": "",
        "DistrictName": "",
        "DivisionCode": "",
        "DivisionName": "",
        "HarvestingTotalWages": "",
        "LocationName": "",
        "OtherTotalWages": "",
        "RegionCode": "",
        "RegionName": "",
        "ShowingTotalWages": "",
        "StatusFlag": "",
        "ThreshingTotalWages": "",
        "WeddingTotalWages": "",
        "Validation": "",
        "Source": "",
        "RemarkCow": "",
        "RemarkBuff": "",
        "RemarkSowing": "",
        "RemarkWeeding": "",
        "RemarkHarvest": "",
        "RemarkThresh": "",
        "RemarkOther": "",
        "RejectRemark": "",
        "CowTotalWagesStyle":"",
        "BuffaloTotalWagesStyle":"",
        "ShowingTotalWagesStyle":"",
        "WeddingTotalWagesStyle":"",
        "HarvestingTotalWagesStyle":"",
        "ThreshingTotalWagesStyle":"",
        "OtherTotalWagesStyle":"",
        "CowTotalWagesIsRequiredRemark":false,
        "BuffaloTotalWagesIsRequiredRemark":false,
        "ShowingTotalWagesIsRequiredRemark":false,
        "WeddingTotalWagesIsRequiredRemark":false,
        "HarvestingTotalWagesIsRequiredRemark":false,
        "ThreshingTotalWagesIsRequiredRemark":false,
        "OtherTotalWagesIsRequiredRemark":false,
        "RemarkCowSelectValue":"",
        "RemarkBuffSelectValue":"",
        "RemarkSowingSelectValue":"",
        "RemarkWeedingSelectValue":"",
        "RemarkHarvestSelectValue":"",
        "RemarkThreshSelectValue":"",
        "RemarkOtherSelectValue":""
       }

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      }


      const storedLanguage = localStorage.getItem('language');

 
useEffect(() => {
         
       const level =  handleUserLevelAccessPermissions(decode_token);
       setButtonAccess(level)
 
       // get District By Division ID
       const getDistrictListByDivision = async () => {
         try {
           const response =  await axios.post(
             `${API_URL}api/geDistrictListByDivisionId`,
             { division_Id: decode_token.id.USER_LEVEL_LOCATION }, config );
           const allDistrict = response.data;
          
          if (allDistrict.status) {
               setDistrictList(allDistrict.data);
               showLoading(false);
           }
           } catch (error) {
           console.error(error);
           showLoading(false);
           }
         }
 
 
 
       // All district list
         const getDistrictList = async () => {
         
             try {
                 const response = await axios.get(`${API_URL}api/getallDistrictList`, config);
                 const allDistrict = response.data;
         
                 if (allDistrict.status) {
                     setDistrictList(allDistrict.data);
                     showLoading(false);
                 }
             } catch (error) {
             console.error(error);
             showLoading(false);
             }
         };
 
       // Set district for district level
      const setDistrictForDistrictLevel = () => {
        const userDistrictCode = decode_token.id.USER_LEVEL_LOCATION;
        const userDistrictName = decode_token.id.LOCATION_NAME;

        const singleDistrict = [{
          DISTRICT_CODE: userDistrictCode,
          DISTRICT_NAME: userDistrictName
        }];

        setDistrictList(singleDistrict);
        setDistrictCode(userDistrictCode);
        setDistrictName(userDistrictName);
        setIsDistrict(true);
        handleDistrictChange(userDistrictCode);
        showLoading(false);
      }

       //Get all Months data    
      const getMonthsList = (e) => { 
         showLoading(true)
             axios
               .get(`${API_URL}api/graph/getMonths/2019`, config)
               .then((res) => {
                 let monthDataResponse = res.data;
                 if (monthDataResponse.status) {
                   setMonth(monthDataResponse.data);
                   showLoading(false)
                 }
               })
               .catch((err) => {
                 console.error(err);
                showLoading(false);
               });
           }
 
 
       const getYearList =()=>{
             setYears(getAllYears());
           }
 
     
 
 
      
  const userRole = async () => {
         showLoading(true)
         try {
           const role = await validateRoles(decode_token)
           if (role) {
             
                 getYearList();
                 getMonthsList();
       
                if(level.userLevel==='DIVISION LEVEL' && level.roles.includes('DIVADM')){
                  getDistrictListByDivision()
                  setIsDivision(true)
                }else if(level.userLevel==='DISTRICT LEVEL'){
                  setDistrictForDistrictLevel()
                }else{
                    getDistrictList()
              }
 
          }else {
         
             alert("You are not an authorized user to capture the data for Pricing");
             navigate("/dashboard");
           }
         } catch (error) {
           console.log(error);
           showLoading(false)
         }
       }
   
   userRole();
   },[]);
 
   const handleDistrictChange = (districtId) => {
     showLoading(true);
     axios
         .post(`${API_URL}api/labourWages/getRuralabourWagesRatesFormWomen`, {
             district_code: districtId
         }, config)
         .then((response) => {
          const { data, status  } = response.data;
          if (status) {
              setBlockAllData(data.GroupCodes);
              setRuralWomenWagesRates([ruralWomenEmptyObject]);
              setAverageData([])
          }
            setTimeout(()=>(showLoading(false)),3000)
         })
         .catch((error) => {
             console.error("Error fetching district data:", error);
             showLoading(false);
         });
 };
 
  //handle on change event 
   const handleDropdownChange=(e)=>{
          
     switch(e.target.name){
      case 'district_name':
          const selectedOption = e.target.options[e.target.selectedIndex];
          const selectedName = selectedOption.text;
            setDistrictName(selectedName)
            setDistrictCode(e.target.value)
            handleDistrictChange(e.target.value)
            setMonthName('')
            setYearName('')
      break;
      case 'month_name':
            setMonthName(e.target.value)
            setYearName('')
            if(districtCode===''){           
              toast.error('Please Select District', messages.COLOR_RED);
               }
      break;
      case 'year_name':
          
              if(districtCode===''){
                toast.error(messages.DISTRICT_MSG, messages.COLOR_RED);
                setYearName('')
                return;
              }
          
            if(monthName===''){
              toast.error(messages.MONTH_MSG, messages.COLOR_RED);
              setYearName('')
                return;
            }

            let currentYear = new Date().getFullYear();
            let selectedYear=parseInt(e.target.value)
  
            if (selectedYear > currentYear) {
                toast.error('Invalid Year Selection.', messages.COLOR_RED);
                return false;
            }else if (selectedYear === currentYear) {
  
              let currentMonth =  new Date().getMonth() + 1;
              let selectedMonth= shortMonthToMonthNumber(monthName);
              currentMonth= currentMonth<10 ? `0${currentMonth}` :currentMonth;
            if(selectedMonth>currentMonth){
                toast.error('Invalid Month Selection.', messages.COLOR_RED);
                setMonthName('')
                setYearName('')
                return false;
            }
          }
              setYearName(e.target.value)
              let postData={
                "district_code": districtCode,
                "month_name": monthName,
                "year_name": e.target.value
              }
             
               onChangeRuralWomenWagesAllData(postData)
 
              
      break;
      default:
        console.log("switch case are not match");
     break;
 
     }
 }
 
 
 
 const onChangeRuralWomenWagesAllData= async (postData)=>{
   showLoading(true)
 
   try {
     const response = await axios
     .post(`${API_URL}api/labourWages/getRuralLabourWagesRatesFormWomenWithData`, postData,config);
      
     // if(response.data.status){
      setRuralWomenWagesRates(response.data.data.GroupCodes);
      setAverageData(response.data.data.average)
         setPayload(response.data.data.payload)
         
         showLoading(false)
     // }
    
   } catch (error) {
     console.error('Error posting data:', error);
     showLoading(false)
   }
 
 }
 
 //reset month, year and District field 
 const resetMothAndYearAndDistrictField=()=>{
   setMonthName('')
   setYearName('')
  if(!isDistrict){
    setDistrictCode('')
    setDistrictName('')
  }
   setRuralWomenWagesRates([ruralWomenEmptyObject]);
   setAverageData('')
   setBlockAllData([])
 }

//remark Dropdown Html
const remarkDropDown=(i)=>{
  let remarkHtml='';
  if(buttonAccess.userLevel==='HEAD QUARTER'){
    remarkHtml= <select 
    className="form-select" 
    name={`remark_${i}`}
    id={`remark_${i}`}
    >
      <option value="">[--Select--]</option>
      <option value="Wages is Too Low.">1</option>
      <option value="Wages is too High.">2</option>
      <option value="Worng entry">3</option>
  </select>

  }else{

    remarkHtml= <select 
    className="form-select" 
    name={`remark_${i}`}
    id={`remark_${i}`}
    >
    <option value="">[--Select--]</option>
    <option value="Wages is Too Low.">1</option>
    <option value="Wages is too High.">2</option>
    <option value="Worng entry">3</option>
  </select>

  }

  return remarkHtml;


}

//handle click button validation
const handleClickButtonValidation=(e,buttonType)=>{
   if(monthName==='' && yearName==='' && districtCode===''){
     toast.error('Please Select District, Wage Month and Wage Year.', messages.COLOR_RED);
     return;
   }
   if(monthName===''){
    toast.error('Please select month.', messages.COLOR_RED);
    return;
   }
   if(yearName===''){
    toast.error('Please select year.', messages.COLOR_RED);
    return;
   }
   return true;
}



  return (
    <>
    <GlobalLoading />
    <ToastContainer/>
       <div className="container-fluid py-3">
       <div className="card mx-3 mb-3">
        <div className="card-body pb-1">
         <div className="row align-items-center">
             <h4 className="page_heading">
             <div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? priceTitle.hi.Rural_Labour_Wage_Rates : priceTitle.en.Rural_Labour_Wage_Rates }} />
              </h4>

              {isDivision &&
                  <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                     <label>{storedLanguage === 'hi' ? titlesData.hi.DIVISION : titlesData.en.DIVISION} </label>
                     <input type="text" readOnly className="form-control" disabled value={decode_token.id.LOCATION_NAME} />
                  </div>
               }
              {isDistrict &&
                  <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                     <label>{storedLanguage === 'hi' ? titlesData.hi.DISTRICT : titlesData.en.DISTRICT}</label>
                     <input type="text" className="form-control" disabled value={decode_token.id.LOCATION_NAME} />
                  </div>
               }
               {!isDistrict &&
                 <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                     <label>{storedLanguage === 'hi' ? titlesData.hi.DISTRICT : titlesData.en.DISTRICT}</label>
                     <select
                      name="district_name"
                      id="district_name"
                      className="form-select"
                     onChange={handleDropdownChange}
                     value={districtCode}
                    >
                   <option value="" disabled>Select District</option>
                   {districtList &&
                     districtList
                       .slice()
                       .sort((a, b) => a.DISTRICT_NAME.localeCompare(b.DISTRICT_NAME))
                       .map((ele, index) => (
                         <option key={index} value={ele.DISTRICT_CODE}>
                           {ele.DISTRICT_NAME}
                         </option>
                       ))}
                 </select>
                 </div>
               }
                
 
                 <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                 <label>{storedLanguage === 'hi' ? titlesData.hi.MONTH : titlesData.en.MONTH}</label>
                  <select  name="month_name"
                   className="form-select"  
                   onChange={handleDropdownChange} 
                   value={monthName}
                   >
                     <option value="" disabled>Select Month</option>
                       {months && months.map((ele, i) => (
                         <option key={i} value={ele.MONTH}>
                         {shortMonthToFull(ele.MONTH)}
                         </option>
                       ))}
                 </select>
                 </div>
 
                 <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                   <label>{storedLanguage === 'hi' ? titlesData.hi.YEAR : titlesData.en.YEAR}</label>
                     <select  name="year_name" 
                      className="form-select" 
                      onChange={handleDropdownChange}  
                       value={yearName} >
                         <option value="" disabled>Select Year</option>
                         {years && years.map((ele, index) => (
                           <option key={index} value={ele}>
                           {ele}
                           </option>
                         )) }
                   </select>
                 </div>
                 <div className="col-xl-6 text-start text-xl-end">
                   { buttonAccess.userLevel === 'HEAD QUARTER'?
                      <>
                      <span className="badge_outlined">1 Wages is Too Low.</span>
                      <span className="badge_outlined">2 Wages is too High.</span>
                      <span className="badge_outlined">3 Worng entry</span>
                      </>
                     
                     :
                     <>
                     <span className="badge_outlined">1 High demand of laboures.</span>
                     <span className="badge_outlined">2 Low demand of laboures.</span>
                     <span className="badge_outlined">3 Entry is correct.</span>
                     <span className="badge_outlined">4 Enter has been amended.</span>
                     </>
                    }

                   
                </div>
             </div>
             
       </div>
     </div>

      <div className="card mx-3 mb-3">
      {blockAllData.length>0 ? (
         <RuralWomenWagesData  
           type="RuralWomenWages" 
           ruralWomenWagesRates={ruralWomenWagesRates}
           blockAllData={blockAllData}
           monthName={monthName}
           yearName={yearName}
           userInfoObject={buttonAccess}  
           config={config} 
           districtCode={districtCode}
           resetMothAndYearAndDistrictField={resetMothAndYearAndDistrictField}
           ruralWomenEmptyObject={ruralWomenEmptyObject}
           averageData={averageData}
           monthAndYearValidation={handleClickButtonValidation}
           payload={payload}
           storedLanguage={storedLanguage}
           priceTitle={priceTitle}
           titlesData={titlesData}
         />
        )
        :
        (
          <div className="card-body">

              <div className="table-responsive">
                <table cellPadding="6" className="table table-bordered text-nowrap text-center">
                            <thead>
                              <tr>
                                  <th rowSpan="3">&nbsp;</th>
                                  <th rowSpan="3">{storedLanguage === 'hi' ? priceTitle.hi.Serial_No : priceTitle.en.Serial_No}</th>
                                  <th rowSpan="2">{storedLanguage === 'hi' ? priceTitle.hi.Business_Measurement : priceTitle.en.Business_Measurement}</th>
                                  <th colSpan="4">{storedLanguage === 'hi' ? priceTitle.hi.Charwaha_Per_Month : priceTitle.en.Charwaha_Per_Month}</th>
                                  <th rowSpan="2" colSpan="2">{storedLanguage === 'hi' ? priceTitle.hi.Sowing : priceTitle.en.Sowing}</th>
                                  <th rowSpan="2" colSpan="2">{storedLanguage === 'hi' ? priceTitle.hi.Weeding : priceTitle.en.Weeding}</th>
                                  <th rowSpan="2" colSpan="2">{storedLanguage === 'hi' ? priceTitle.hi.Harvesting : priceTitle.en.Harvesting}</th>
                                  <th rowSpan="2" colSpan="2">{storedLanguage === 'hi' ? priceTitle.hi.Threshing : priceTitle.en.Threshing}</th>
                                  <th rowSpan="2" colSpan="2">{storedLanguage === 'hi' ? priceTitle.hi.Other : priceTitle.en.Other}</th>
                              </tr>
                              <tr>
                                  <th colSpan="2">{storedLanguage === 'hi' ? priceTitle.hi.Cow : priceTitle.en.Cow}</th>
                                  <th colSpan="2">{storedLanguage === 'hi' ? priceTitle.hi.Buffalow : priceTitle.en.Buffalow}</th>
                              </tr>
                              <tr>
                                  <th>{storedLanguage === 'hi' ? priceTitle.hi.Block : priceTitle.en.Block}</th>
                                  <th>{storedLanguage === 'hi' ? priceTitle.hi.Total_Wages : priceTitle.en.Total_Wages}</th>
                                  <th>{storedLanguage === 'hi' ? priceTitle.hi.REMARKS : priceTitle.en.REMARKS}</th>
                                  <th>{storedLanguage === 'hi' ? priceTitle.hi.Total_Wages : priceTitle.en.Total_Wages}</th>
                                  <th>{storedLanguage === 'hi' ? priceTitle.hi.REMARKS : priceTitle.en.REMARKS}</th>
                                  <th>{storedLanguage === 'hi' ? priceTitle.hi.Total_Wages : priceTitle.en.Total_Wages}</th>
                                  <th>{storedLanguage === 'hi' ? priceTitle.hi.REMARKS : priceTitle.en.REMARKS}</th>
                                  <th>{storedLanguage === 'hi' ? priceTitle.hi.Total_Wages : priceTitle.en.Total_Wages}</th>
                                  <th>{storedLanguage === 'hi' ? priceTitle.hi.REMARKS : priceTitle.en.REMARKS}</th>
                                  <th>{storedLanguage === 'hi' ? priceTitle.hi.Total_Wages : priceTitle.en.Total_Wages}</th>
                                  <th>{storedLanguage === 'hi' ? priceTitle.hi.REMARKS : priceTitle.en.REMARKS}</th>
                                  <th>{storedLanguage === 'hi' ? priceTitle.hi.Total_Wages : priceTitle.en.Total_Wages}</th>
                                  <th>{storedLanguage === 'hi' ? priceTitle.hi.REMARKS : priceTitle.en.REMARKS}</th>
                                  <th>{storedLanguage === 'hi' ? priceTitle.hi.Total_Wages : priceTitle.en.Total_Wages}</th>
                                  <th>{storedLanguage === 'hi' ? priceTitle.hi.REMARKS : priceTitle.en.REMARKS}</th>
                              </tr>
                          </thead>
                          <tbody>
                        
                              <tr>
                                <td>
                                {/* <input 
                                  type="checkbox"
                                  id={`checkbox`}
                                  readOnly
                                  /> */}
                                  </td>
                                  <td>1</td>
                                  <td>
                                      <select 
                                        className="form-select" 
                                        disabled
                                        readOnly
                                        >
                                          <option>Select</option>
                                            <option  value='' >
                                              Test
                                          </option>
                                        
                                      </select>
                                  </td>
                                  <td>
                                      <input 
                                      type="text" 
                                      className="form-control"
                                      maxLength="6"
                                      name={`CowTotalWages`}
                                      id={`CowTotalWages`}
                                      readOnly
                                      
                                      />
                                  </td>
                                  <td>
                                    {remarkDropDown('1')}
                                  </td>
                                  <td>
                                      <input 
                                      type="text" 
                                      className="form-control"
                                      maxLength="6"
                                      name={`BuffaloTotalWages`}
                                      id={`BuffaloTotalWages`}
                                      readOnly
                                    />
                                  </td>
                                  <td>
                                  {remarkDropDown('2')}
                                  </td>
                                  <td>
                                      <input 
                                      type="text" 
                                      className="form-control"
                                      maxLength="6"
                                      name={`ShowingTotalWages`}
                                      id={`ShowingTotalWages`}
                                      readOnly
                                      />
                                  </td>
                                  <td>
                                  {remarkDropDown('3')}
                                  </td>
                                  <td>
                                    
                                      <input 
                                      type="text" 
                                      className="form-control"
                                      name={`WeddingTotalWages`}
                                      id={`WeddingTotalWages`}
                                      maxLength="6"
                                      readOnly
                                    />
                                  </td>
                                  <td>
                                  {remarkDropDown('4')}
                                  </td>
                                  <td>
                                  
                                  <input 
                                      type="text" 
                                      className="form-control"
                                      maxLength="6"
                                      name={`HarvestingTotalWages`}
                                      id={`HarvestingTotalWages`}
                                      readOnly
                                    />
                                  </td>
                                  <td>
                                  {remarkDropDown('5')}
                                  </td>
                                  <td>
                                  
                                  <input 
                                      type="text" 
                                      className="form-control"
                                      maxLength="6"
                                      name={`ThreshingTotalWages`}
                                      id={`ThreshingTotalWages`}
                                      readOnly
                                    />
                                  </td>
                                  <td>
                                  {remarkDropDown('5')}
                                  </td>
                                  <td>
                                  
                                  <input 
                                      type="text" 
                                      className="form-control"
                                      maxLength="6"
                                      name={`OtherTotalWages`}
                                      id={`OtherTotalWages`}
                                      readOnly
                                    />
                                  </td>
                                  <td>
                                  {remarkDropDown('6')}
                                  </td>
                                
                              </tr>
                          

                              <tr>
                                  <td colSpan="2" className="fw-bold">Remark</td>
                                  <td colSpan="15">
                                      <textarea 
                                      readOnly
                                      className="form-control h-auto" 
                                      value=''
                                      rows="3">
                                      </textarea>
                                  </td>
                              </tr>
                          </tbody>
                      </table>


              </div>

            <div className="row">
              <div className="col-12 text-center pt-3">
                <button
                  type="button"
                  className="btn btn_orange mx-1"
                  onClick={(e)=>handleClickButtonValidation(e,'SAVE')} 
                >
                  AddRow
                </button>

                <button
                  type="button"
                  className="btn btn_orange mx-1"
                  onClick={(e)=>handleClickButtonValidation(e,'SAVE')} 
                >
                  DeleteRow
                </button>
                <button 
                  type="button" 
                  className="btn btn_orange mx-1"
                  onClick={(e)=>handleClickButtonValidation(e,'SAVE')} 
                >
                  Save
                </button>

                {(buttonAccess.userLevel ==='HEAD QUARTER') ?
                  <>
                  <button 
                  type="submit" 
                  className="btn btn_orange mx-1 "
                  onClick={(e)=>handleClickButtonValidation(e,'ACCEPT')} 
                  >
                  Accept
                </button>
                  <button 
                  type="submit" 
                  className="btn btn_orange mx-1"
                  onClick={(e)=>handleClickButtonValidation(e,'REJECT')} 
                  >
                  Reject
                </button>
                  </>
                :
                 <button
                  type="submit"
                  className="btn btn_orange mx-1"
                  onClick={(e) => handleClickButtonValidation(e, 'SUBMIT')}
                  >
                  Submit
                </button>

                }
                <button 
                  type="reset" 
                  className="btn btn_orange mx-1"
                  onClick={resetMothAndYearAndDistrictField} 
                  >
                  Reset
                </button>

                <button 
                type="button" 
                className="btn btn_orange mx-1" 
                onClick={(e)=>( navigate("/dashboard"))} 
                >
                Cancel
                </button>
              </div>
            </div>

         </div>


        ) }

           
  
    </div>
</div>

 
    
    </>
  )
}

export default RuralWomenWages